import { render, staticRenderFns } from "./CustomerTable.vue?vue&type=template&id=771b27a0&scoped=true&"
import script from "./CustomerTable.vue?vue&type=script&lang=js&"
export * from "./CustomerTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTable.vue?vue&type=style&index=0&id=771b27a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771b27a0",
  null
  
)

export default component.exports